<script setup>
import BaseBubble from 'next/message/bubbles/Base.vue';
import ItemCard from '../Lazada/ItemCard.vue';
import OrderCard from '../Lazada/OrderCard.vue';
import { useMessageContext } from '../../provider.js';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
const { t } = useI18n();

const { contentAttributes } = useMessageContext();
const original = computed(() => contentAttributes.value?.original || {});
const cached = computed(() => contentAttributes.value?.loadedData || {});

const isItem = computed(() => {
  return original.value?.itemId;
});

const isOrder = computed(() => {
  return original.value?.orderId;
});
</script>

<template>
  <BaseBubble data-bubble-name="lazada-card">
    <ItemCard v-if="isItem" :cached="cached" />
    <OrderCard v-else-if="isOrder" :original="original" :cached="cached" />
    <template v-else>
      <p class="px-2 py-1">
        {{ t('CONVERSATION.LAZADA.UNSUPPORTED_CARD') }}
      </p>
    </template>
  </BaseBubble>
</template>
